import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/context/use-auth';

export function BillingSuccess() {
  const navigate = useNavigate();
  const location = useLocation();
  const { isLoading: isAuthLoading } = useAuth();

  // Get return URL from query params or default to home
  const searchParams = new URLSearchParams(location.search);
  const returnUrl = searchParams.get('returnUrl') || '/';

  useEffect(() => {
    // Wait for auth to finish loading
    if (isAuthLoading) {
      return;
    }
    
    // Redirect after 2 seconds
    const timer = setTimeout(() => {
      navigate(returnUrl);
    }, 2000);
    
    return () => clearTimeout(timer);
  }, [isAuthLoading, navigate, returnUrl]);

  return (
    <div className="min-h-screen bg-[var(--bg-primary)] flex items-center justify-center">
      
      <div className="text-center px-4">
        {isAuthLoading && (
          <>
            <div className="w-12 h-12 border-2 border-[var(--accent)] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
            <h1 className="font-body text-xl font-semibold text-[var(--text-primary)] mb-2">
              Processing...
            </h1>
            <p className="font-ui text-sm text-[var(--text-secondary)]">
              Checking authentication...
            </p>
          </>
        )}

        {!isAuthLoading && (
          <>
            <div className="w-16 h-16 bg-green-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <h1 className="font-body text-2xl font-semibold text-[var(--text-primary)] mb-2">
              Purchase Complete!
            </h1>
            <p className="font-ui text-sm text-[var(--text-secondary)] mb-6">
              Your purchase was successful!
            </p>
            <button
              onClick={() => navigate(returnUrl)}
              className="px-6 py-3 bg-[var(--accent)] text-[var(--bg-primary)] font-ui text-sm font-medium rounded-xl hover:bg-[var(--accent)]/90 transition-colors"
            >
              Return to Story
            </button>
          </>
        )}
      </div>
    </div>
  );
}
